import { Component, Output, EventEmitter, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "sot-amount",
  templateUrl: "./amount.component.html",
  styleUrls: ["./amount.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class Amount {
  @Input() amount: number = 0;
  @Output() amountChange = new EventEmitter<number>();
  @Output() increment = new EventEmitter<number>();
  @Output() decrement = new EventEmitter<number>();
  @Input() min: number = 0;
  @Input() max: number = 99;

  constructor() { }

  public amountMinus() {
    const new_amount = Math.max(this.amount - 1, this.min);
    if (this.amount !== new_amount) {
      this.amountChange.emit(new_amount);
      this.decrement.emit();
      // Emitting already triggers ChangeDetection for OnPush, no need for PushChanges
      // ! Remember to listen to amountChanges and update amount on parent
    }
  }

  public amountPlus() {
    const new_amount = Math.min(this.amount + 1, this.max);
    if (this.amount !== new_amount) {
      this.amountChange.emit(new_amount);
      this.increment.emit();
      // Emitting already triggers ChangeDetection for OnPush, no need for PushChanges
      // ! Remember to listen to amountChanges and update amount on parent
    }
  }
}
